// extracted by mini-css-extract-plugin
export default {"container":"_2KfYo","pluginButton":"_2dX1u"};